module.exports = __webpack_public_path__ + "6efeb031e4eb8f32dc89922ad2738f3c.MP3";